module.exports = __webpack_public_path__ + "img/141.1.35037e57.jpg";